import React from 'react';

const CountryFilterIcon = (props: any) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12.5008 2.50781V7.49927" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M7.50082 3.98438V15.8339" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M17.5003 8.33288V4.6772C17.5003 4.31805 17.2703 3.99973 16.9303 3.8864L13.0271 2.58562C12.6838 2.47146 12.3138 2.47146 11.9705 2.58562L8.02738 3.89973C7.6849 4.0139 7.31575 4.0139 6.97327 3.89973L3.59759 2.77478C3.05845 2.59479 2.50098 2.99644 2.50098 3.56558V13.0144C2.50098 13.3302 2.6793 13.6193 2.96179 13.7602L6.75578 15.6567C7.22492 15.8917 7.77739 15.8909 8.24654 15.6567L10.0006 14.7793"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.9941 17.2646C15.6725 17.5771 15.1634 17.5771 14.8417 17.2646C13.9909 16.4388 12.501 14.7689 12.501 13.2056C12.501 11.5948 13.8067 10.2891 15.4175 10.2891C17.0283 10.2891 18.334 11.5948 18.334 13.2056C18.334 14.7689 16.8441 16.4388 15.9941 17.2646Z"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.416 12.9032C15.296 12.9032 15.1993 13.0007 15.2001 13.12C15.2001 13.24 15.2976 13.3367 15.4168 13.3367C15.5361 13.3367 15.6336 13.2392 15.6336 13.12C15.6336 12.9999 15.5369 12.9032 15.416 12.9032"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CountryFilterIcon;
